<ion-content class="ion-padding">
  <div class="add-option-modal">
    <h1>Add Modifier</h1>
    <p>Create New Text Modifier or import Existing Menu Item as a Modifier</p>
    <ng-container [formGroup]="form">
      <div class="add-option-modal__form">
        <ion-list>
          <ion-radio-group color="warning" mode="md" [value]="modifierType" (ionChange)="onRadioOptionChange($event)">
            <ion-item lines="none" *ngFor="let item of MODIFIER_OPTIONS">
              <ion-radio slot="start" [value]="item.value"></ion-radio>
              <ion-label>{{item.name}}</ion-label>
            </ion-item>
          </ion-radio-group>
        </ion-list>

        <ng-container [ngSwitch]="modifierType">
          <ng-container *ngSwitchCase="'text'">
            <div>
              <ion-label><strong>Name</strong> (required)</ion-label>
              <ion-input formControlName="name" maxlength="50"></ion-input>
            </div>
            <div>
              <ion-label><strong>Price</strong> (optional)</ion-label>
              <ion-input type="number" formControlName="price"></ion-input>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'pos_product'">
            <div>
              <ng-select placeholder="Search" formControlName="product" [items]="products" bindLabel="name"
                         class="pos-manager-option-dropdown"></ng-select>
            </div>
          </ng-container>
          <div *ngSwitchCase="'category'">
            <ng-select placeholder="Search" formControlName="category" class="pos-manager-option-dropdown"
                       [items]="categories" bindLabel="name"></ng-select>
          </div>
        </ng-container>
      </div>
      <div class="add-option-modal__actions">
        <ion-button color="clear" debounce-click [debounceTime]="0" (debounceClick)="cancel()">Cancel</ion-button>
        <ion-button [disabled]="!form.valid || !form.dirty" color="dark" debounce-click [debounceTime]="0"
                    (debounceClick)="submit()">Add</ion-button>
      </div>
    </ng-container>
  </div>
</ion-content>